module.exports = __webpack_public_path__ + "static/media/searchIcon.f3e4c894.svg";